var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 533.5 544.3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M533.5 278.4c0-17.4-1.5-34-4.4-50.2H272v95h146.9c-6.4 35-25.5 64.7-54.5 84.6v70h87.9c51.6-47.6 81.2-117.6 81.2-199.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M272 544.3c73.5 0 135.3-24.3 180.4-66v-55.9h-87.9c-24.5 16.4-55.8 26-92.5 26-71 0-131-47.8-152.5-112.1h-89.3v70.3c45.7 90 139.5 143.7 241.8 143.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M119.5 324.9c-7.8-23.6-7.8-49.1 0-72.7v-70.3h-89.3c-37.4 73.5-37.4 160.5 0 234z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M272 107.7c39.9 0 75.9 13.7 104.2 40.8l78.1-78.1C407.3 24.3 345.5 0 272 0c-102.3 0-196.1 53.8-241.8 143.7l89.3 70.3C141 155.5 201 107.7 272 107.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.473bb162b3079bb8ace1f96db0aca631.svg";
export { ForwardRef as ReactComponent };